import React from 'react';
import { ChatBubbleIcon } from '@radix-ui/react-icons';

import styles from './comment-count.module.scss';
interface CommentCountProps {
  count?: number;
}

export const CommentCount: React.FC<CommentCountProps> = ({ count = 0 }) => (
  <div className={styles['container']}>
    <ChatBubbleIcon />
    <span>{count}</span>
  </div>
);
